export enum AnalyticsEventTypes {
  NETWORK_CALL_EVENT = 'NETWORK_CALL_EVENT',
  CRASH_EVENT = 'CRASH_EVENT',
  TIMER_EVENT = 'TIMER_EVENT',
  MESSAGE_EVENT = 'MESSAGE_EVENT',
  V1_EVENT = 'V1_EVENT',
}
